import { Button, Box } from '@mui/material';
import React from 'react';
import { useNavigate, useNavigation } from 'react-router-dom';
import { RuleSet } from '../../types/ruleSetTypes';
import OrgInputTextField from '../../components/OrgInputTextField';
import { useTranslation } from 'react-i18next';

interface OrgNumberInputProps {
  ruleSets: RuleSet[];
}

export default function OrgNumberInput(props: OrgNumberInputProps) {
  const { t } = useTranslation();
  const { ruleSets } = props;

  const navigate = useNavigate();
  const navigation = useNavigation();
  // const theme = useTheme();
  // const isDarkMode = theme.palette.mode === 'dark';
  
  const [orgNumber, setOrgNumber] = React.useState('');
  const [ruleSet] = React.useState(ruleSets.length !== 0 ? ruleSets[0] : undefined as RuleSet | undefined);

  const handleValidOrgNumberEntered = (orgNumber: string) => {
    setOrgNumber(orgNumber);
  };

  const handleInvalidOrgNumberEntered = () => {
    setOrgNumber('');
  }

  // const handleRuleSetChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   const ruleSetId = event.target.value;
  //   const selectedRuleSet = ruleSets.find((ruleSet) => ruleSet.id === ruleSetId);
  //   setRuleSet(selectedRuleSet);
  // };

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    if (!disabled && orgNumber) {
      navigate(`/companyassessment/${orgNumber}${ruleSet ? `?ruleSetId=${ruleSet.id}` : ''}`);
    }
  };

  const disabled = navigation.state === 'loading';

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{
      display: 'flex', gap: 1, alignItems: 'center', minWidth: 0, maxWidth: '100%',
      '& .MuiAutocomplete-root': { minWidth: 0, width: { xs: 220, sm: 320 }, flex: '1 1 auto' },
    }}>
      <OrgInputTextField
        disabled={disabled}
        textFieldProps={{
          label: t('monitoring.overview.companyNameOrNumber'),
          sx: {
            width: '100%',
            '& .MuiOutlinedInput-root': {
              height: '40px',
              bgcolor: 'background.paper',
              borderRadius: '8px',
              '& fieldset': {
                borderColor: 'divider',
              },
              '&:hover fieldset': {
                borderColor: 'action.active',
              },
            }
          }
        }}
        onValidOrgNumberEntered={handleValidOrgNumberEntered}
        onInvalidOrgNumberEntered={handleInvalidOrgNumberEntered}
      />
      {/* {ruleSets.length !== 0 && (
        <TextField
          disabled={disabled}
          size="small"
          type="text"x
          name="ruleSet"
          label={t('assessment.details.ruleSet')}
          select
          slotProps={ {select: { native: true }} }
          onChange={handleRuleSetChange}
        >
          {ruleSets.map((ruleSet) => (
            <option key={ruleSet.id} value={ruleSet.id}>{ruleSet.name}</option>
          ))}
        </TextField>
      )} */}
        <Button
          disabled={disabled || !orgNumber}
          variant="contained"
          size="small"
          type="submit"
          sx={{
            height: 40,
            flexShrink: 0,
          }}
        >
          {t('assessment.details.submit')}
        </Button>
    </Box>
  );
}
